export const style = {
  header: {
    size: 'lg',
    textAlign: 'center',
    paddingY: 6,
  },
  numberFields: {
    alignItems: 'flex-start',
  },
  buttons: {
    w: 'full',
    marginY: 6,
  },
};
